package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** A pin names an existing immutable version; it never copies or rewrites the document. */
@Serializable
data class CreateDesignSnapshotRequest(val version: Int, val name: String, val note: String? = null)

/** The explicit metadata revision fences stale renames and survives deleting and recreating a pin. */
@Serializable
data class UpdateDesignSnapshotRequest(val name: String, val note: String? = null, val baseRevision: Int)

/** Naming provenance is distinct from the original version's saved-by provenance. */
@Serializable
data class DesignSnapshotDto(
    val version: Int,
    val name: String,
    val note: String? = null,
    val revision: Int,
    val namedBy: String,
    val namedAt: String,
    val updatedBy: String,
    val updatedAt: String,
)
